export default __webpack_public_path__ + "static/media/crypto.48686bac.svg";